module.exports = __webpack_public_path__ + "img/twitter.8b33bec.svg";